/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

export const SET_SPW_ACCESS_CODE = 'SET_SPW_ACCESS_CODE';

export function setSPWAccessCode(payload) {
    return {type: SET_SPW_ACCESS_CODE, payload: payload};
}

export const SET_SUBSCRIPTION_LENGTH = 'SET_SUBSCRIPTION_LENGTH';

export function setSubscriptionLength(payload) {
    return {type: SET_SUBSCRIPTION_LENGTH, payload: payload};
}

export const SET_ACCESS_CODE_INFO = 'SET_ACCESS_CODE_INFO';

export function fetchAccessCodeSuccess(payload) {
    return {type: SET_ACCESS_CODE_INFO, payload: payload};
}



// WEBPACK FOOTER //
// ./src/_actions/access.code.actions.js